import React from 'react';
import Spacer from 'features/shared/Spacer';
import { DateTime, InnerText, ItemHeader } from './styles';
import { BlueLink } from 'features/shared/ui/Button';
import { LogClick } from 'features/shared/ClickStream';

export interface Props {
  month: string;
  date: string;
  name: string;
  target: string;
  details: string[];
  webinarId: string;
}

const getLink = (webinarId: string) => `https://uchi.ru/webinars/webinar/${webinarId}?utm_source=site&utm_medium=links&utm_campaign=b2t_${webinarId}_kabmun_web`;

export const Item = ({ date, name, target, details, webinarId }: Props) => (
  <>
    <DateTime>{date}</DateTime>
    <Spacer size={4} />
    <ItemHeader>{name}</ItemHeader>
    <Spacer size={8} />
    <LogClick
      eventType="webinar-link-click"
      eventInfo="Клик по ссылке на вебинар"
      eventSource="webinars-page"
      cd1={webinarId}
    >
      <BlueLink href={getLink(webinarId)} target="_blank">
        Ссылка на вебинар
      </BlueLink>
    </LogClick>
    {/* {target && (
      <>
        <Spacer size={8} />
        <InnerText>{target}</InnerText>
      </>
    )}
    {details?.length > 0 && (
      <>
        <Spacer size={12} />
        {details.map((detail, index, array) => (
          <InnerText>
            - {detail}
            {index === array.length - 1 ? '.' : ';'}
          </InnerText>
        ))}
      </>
    )} */}
    <Spacer size={56} />
  </>
);
